module.exports = __webpack_public_path__ + "static/media/bulb-orange.2681dbe6.svg";